/**
 * 共通ポップアップコンポーネント
 */
/**
 * エラーメッセージなどをポップアップで表示する
 * @param options ポップアップオプション
 */
export function showPopupAlert(options) {
    // 既に表示されているポップアップがある場合はスキップ
    const existingPopup = document.querySelector('.popup-modal');
    if (existingPopup) {
        return;
    }
    const { text, showBackdrop = false, closeOnBackdropClick = false, traceId, onClose } = options;
    // ポップアップ要素を生成
    const popup = document.createElement('div');
    popup.className = showBackdrop ? 'popup-modal' : 'popup-modal popup-modal-no-backdrop';
    // コンテナ
    const container = document.createElement('div');
    container.className = 'popup-modal-container';
    // メッセージ
    const messageDiv = document.createElement('div');
    messageDiv.className = 'popup-message';
    messageDiv.textContent = text;
    container.appendChild(messageDiv);
    // traceID
    if (traceId) {
        const traceIdDiv = document.createElement('div');
        traceIdDiv.className = 'popup-trace-id';
        const traceIdText = document.createElement('span');
        traceIdText.className = 'popup-trace-id-text';
        traceIdText.textContent = `トレースNo: ${traceId}`;
        const traceIdCopy = document.createElement('span');
        traceIdCopy.className = 'popup-trace-id-copy material-icons';
        traceIdCopy.textContent = 'content_copy';
        traceIdDiv.appendChild(traceIdText);
        traceIdDiv.appendChild(traceIdCopy);
        container.appendChild(traceIdDiv);
        // traceIDコピーボタンのイベント
        traceIdCopy.addEventListener('click', () => {
            navigator.clipboard.writeText(traceId).then(() => {
                traceIdCopy.textContent = 'check';
                setTimeout(() => {
                    traceIdCopy.textContent = 'content_copy';
                }, 2000);
            }).catch((err) => {
                console.error('クリップボードへのコピーに失敗しました:', err);
            });
        });
    }
    // ボタンコンテナ
    const buttonsDiv = document.createElement('div');
    buttonsDiv.className = 'popup-buttons';
    const closeBtn = document.createElement('button');
    closeBtn.className = 'popup-btn popup-btn-close';
    closeBtn.type = 'button';
    closeBtn.textContent = '閉じる';
    buttonsDiv.appendChild(closeBtn);
    container.appendChild(buttonsDiv);
    popup.appendChild(container);
    // 背景クリックで閉じる
    if (closeOnBackdropClick) {
        popup.addEventListener('click', (e) => {
            if (e.target === popup) {
                popup.remove();
            }
        });
    }
    // 閉じるボタンのイベント
    closeBtn.addEventListener('click', () => {
        popup.remove();
        if (onClose) {
            onClose();
        }
    });
    // DOMに追加して表示
    document.body.appendChild(popup);
}
/**
 * 確認ダイアログを表示する
 * @param options ポップアップオプション
 */
export function showPopupConfirm(options) {
    // 既に表示されているポップアップがある場合はスキップ
    const existingPopup = document.querySelector('.popup-modal');
    if (existingPopup) {
        return;
    }
    const { text, showBackdrop = false, rightButtonText = 'OK', onConfirm } = options;
    // ポップアップ要素を生成
    const popup = document.createElement('div');
    popup.className = showBackdrop ? 'popup-modal' : 'popup-modal popup-modal-no-backdrop';
    // コンテナ
    const container = document.createElement('div');
    container.className = 'popup-modal-container';
    // メッセージ
    const messageDiv = document.createElement('div');
    messageDiv.className = 'popup-message';
    messageDiv.textContent = text;
    container.appendChild(messageDiv);
    // ボタンコンテナ
    const buttonsDiv = document.createElement('div');
    buttonsDiv.className = 'popup-buttons';
    // キャンセルボタン
    const cancelBtn = document.createElement('button');
    cancelBtn.className = 'popup-btn popup-btn-close';
    cancelBtn.type = 'button';
    cancelBtn.textContent = 'キャンセル';
    // 確認ボタン
    const confirmBtn = document.createElement('button');
    confirmBtn.className = 'popup-btn popup-btn-confirm';
    confirmBtn.type = 'button';
    confirmBtn.textContent = rightButtonText;
    buttonsDiv.appendChild(cancelBtn);
    buttonsDiv.appendChild(confirmBtn);
    container.appendChild(buttonsDiv);
    popup.appendChild(container);
    // キャンセルボタンのイベント
    cancelBtn.addEventListener('click', () => {
        popup.remove();
    });
    // 確認ボタンのイベント
    confirmBtn.addEventListener('click', () => {
        popup.remove();
        if (onConfirm) {
            onConfirm();
        }
    });
    // DOMに追加して表示
    document.body.appendChild(popup);
}
